import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProductListItemListMHComponent } from './product-list-item-list.component';
import { PriceCardPriceModule } from '../../../../price/card-price/price-card-price.module';
import { ProductFavoriteIconModule } from '../../../favorite-icon/product-favorite-icon.module';
import { LoadingIndicatorComponent } from 'projects/shared/lib/components/shared/base/loading-indicator/loading-indicator.component';
import { ProductAddToCartTemplateIconComponent } from 'projects/shared/lib/components/shared/product/add-to-cart-template-icon/product-add-to-cart-template-icon.component';
import { QuantityInputBareModule } from '../../../../quantity-input/quantity-input-bare/quantity-input-bare.module';
import { ProductTagListComponent } from 'projects/shared/lib/components/shared/product/tag/list/product-tag-list.component';
import { PackagingToStringPipe } from 'projects/shared/lib/pipes/packaging/packaging-to-string.pipe';
import { ProductTagPictogramComponent } from 'projects/shared/lib/components/shared/product/tag/pictogram/product-tag-pictogram.component';
import { QuantityUnitToPluralStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-plural-string.pipe';
import { QuantityUnitToStringPipe } from 'projects/shared/lib/pipes/quantity-unit/quantity-unit-to-string.pipe';

@NgModule({
  declarations: [
    ProductListItemListMHComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,

    PriceCardPriceModule,
    ProductFavoriteIconModule,
    ProductAddToCartTemplateIconComponent,
    LoadingIndicatorComponent,
    QuantityInputBareModule,
    ProductTagListComponent,
    PackagingToStringPipe,
    QuantityUnitToPluralStringPipe,
    QuantityUnitToStringPipe,
    ProductTagPictogramComponent
  ],
  exports: [
    ProductListItemListMHComponent,
  ]
})
export class ProductListItemListModule { }
